import React from 'react';

import { MenuItem } from 'src/app/components/lib/menu-item';
import { Select } from 'src/app/components/lib/select';

import { useTimeSelect } from './use-time-select';

type TimeSelectProps = {
  automationId?: string;
  className?: string;
  disabled?: boolean;
  errorMessage?: string;
  gridColumns?: number;
  hoursOnly?: boolean | null;
  label: string;
  labelPlacement?: 'start' | 'top';
  maxTimeWindowInHours?: number;
  nullOptionLabel?: string;
  onChange: (value: string | null) => void;
  placeholder?: string;
  required?: boolean;
  selectedValue: string | null;
  startTime?: string | null;
  width?: string;
};

export function TimeSelect({
  disabled,
  hoursOnly,
  label,
  automationId,
  maxTimeWindowInHours,
  onChange,
  errorMessage,
  startTime,
  selectedValue,
  placeholder,
  required,
  labelPlacement = 'start',
  width,
  className,
  gridColumns,
  nullOptionLabel,
}: TimeSelectProps) {
  // the logic in this hook can/should probably be moved to the parent component once that component is refactored to be a function
  const { handleChange, options } = useTimeSelect({
    maxTimeWindowInHours,
    onChange,
    startTime,
    selectedValue,
    hoursOnly,
    nullOptionLabel,
  });

  return (
    <Select
      automationId={automationId}
      className={className}
      disabled={disabled}
      errorMessage={errorMessage}
      gridColumns={gridColumns}
      label={label}
      labelPlacement={labelPlacement}
      placeholder={nullOptionLabel ?? placeholder ?? 'Select a time'}
      required={required}
      value={selectedValue ?? ''}
      width={width}
      onChange={handleChange}
    >
      {options.map((option) => (
        <MenuItem key={option.text} value={option.value}>
          {option.text}
        </MenuItem>
      ))}
    </Select>
  );
}
